import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import * as ReactSpark from "react-spark";

const { Link, Type, Stack } = ReactSpark;

class FooterDisclaimer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            shouldRenderBanner: false,
        };
    }
    componentDidMount() {
        const currentBannerTimeUTC = Date.now();
        // 06/18/2024 6:00AM ET
        const creditCardReductionStartTimeUTC = Date.UTC(2024, 5, 18, 10, 0, 0, 0);
        // 06/18/2024 11:59PM ET
        const creditCardReductionEndTimeUTC = Date.UTC(2024, 5, 19, 3, 59, 59, 0);
        if (currentBannerTimeUTC >= creditCardReductionStartTimeUTC && currentBannerTimeUTC <= creditCardReductionEndTimeUTC) {
            this.setState({
                shouldRenderBanner: true
            });
        }
    }

    render() {
        const { shouldRenderBanner } = this.state
        const { appUrl, EHOLogo } = this.props;
        return (
            <Fragment>
                <Stack
                    itemSpacing="medium"
                    splitAt="medium"
                    className="sprk-o-Stack__item"
                >
                    <Stack.Item
                        width="two-fifths"
                        breakpoint="medium"
                        className="sprk-o-Stack sprk-o-Stack--medium"
                    >
                        <Type.BodyFour className="sprk-o-Stack__item">
                            Copyright protected {new Date().getFullYear()}{" "}
                            RockLoans Marketplace LLC. All rights reserved.
                        </Type.BodyFour>
                        <Type.BodyFour className="sprk-o-Stack__item">
                            <sup>1</sup>Based on Rocket Mortgage data in
                            comparison to public data records.
                        </Type.BodyFour>
                    </Stack.Item>
                    <Stack.Item
                        width="flex"
                        breakpoint="medium"
                    >
                        <Stack
                            splitAt="min"
                            className="sprk-o-Stack__item sprk-o-Stack--center-column sprk-o-Stack--end-row@m"
                        >
                            <Stack.Item breakpoint="min" className="sprk-u-mrm">
                                <a
                                    href="http://www.bbb.org/detroit/business-reviews/loans/rocketloans-in-detroit-mi-90028118/#bbbonlineclick"
                                    target="_blank"
                                    rel="noopener noreferrer nofollow"
                                >
                                    <img
                                        src="https://seal-easternmichigan.bbb.org/seals/blue-seal-250-52-whitetxt-bbb-90028118.png"
                                        alt="Rocket Loans BBB Business Review"
                                        title="Rocket Loans BBB Business Review"
                                        className="img-responsive"
                                    />
                                </a>
                            </Stack.Item>
                            <Stack.Item
                                breakpoint="min"
                                className="sprk-u-phs"
                            >
                                <img
                                    src={EHOLogo}
                                    className="img-responsive"
                                    alt="Equal housing icon"
                                    title="Equal Housing"
                                />
                            </Stack.Item>
                        </Stack>
                    </Stack.Item>
                </Stack>
                {window.location.hash === "#/" && shouldRenderBanner &&
                    <Type.BodyFour>
                        *This promotion expires at 11:59pm ET on June 18, 2024. The offer is only available to clients who close a personal loan with Rocket Loans before 11:59pm ET June 18, 2024. Offer is non-transferable and cannot be retroactively applied to previously closed loans. Offer cannot be combined with other Rocket Loans offers. This is not a commitment to lend. $100 prepaid e-gift card will be emailed within 45 days of closing.
                    </Type.BodyFour>
                }
                <Type.BodyFour>
                    All loans are made by Cross River Bank, a New Jersey state
                    chartered commercial bank, Member FDIC, Equal Housing Lender.
                    All loans are unsecured, fully amortizing personal loans.
                    Eligibility for a loan is not guaranteed. This is not a deposit product.
                    Please refer to our{" "}
                    <Link href="/disclosures-and-licenses">
                        Disclosures and Licenses
                    </Link>{" "}
                    page for state-required disclosures, licenses, and lending
                    restrictions.
                    <br />
                    Qualified clients using Rocket Loans will see loan
                    options for a 36 or 60 month term, and APR ranges from a minimum of 8.01%
                    (rate with autopay discount) to a maximum of 29.99% (rate without autopay
                    discount) depending upon their credit profile. An origination fee of up to 9.99% is
                    charged for each loan. This fee is deducted from the balance before funds are
                    disbursed to the client. For example, a 5-year $16,000 loan with a 14.55% interest
                    rate and a 6.95% ($1,112) origination fee would have 59 scheduled monthly payments
                    of approximately $376.83 and 1 final monthly payment of approximately $399.09 for an APR of 17.90%.
                    Borrower must be a U.S. citizen or permanent U.S. resident at least 18 years of age.
                    All loan applications are subject to credit review and approval and offered loan terms depend upon
                    credit score, requested amount, requested loan term, credit usage, credit history
                    and other factors. Not all borrowers receive the lowest interest rate or highest loan amount.
                    To qualify for the lowest rate, you must have excellent credit, meet certain conditions,
                    and select autopay. To qualify for loan amounts from $45,001 to $75,000, you must be a returning 
                    Rocket Loans client in good standing or have an existing mortgage relationship in good standing 
                    with one of Rocket Loans' sister companies, Rocket Mortgage or Mr. Cooper (Mr. Cooper owned 
                    mortgages only). Rates and Terms are subject to change at any time without notice.
                    <br />
                    Ohio Residents: All loans to Ohio residents must be greater than $5,001. The Ohio laws against discrimination require that all creditors make credit equally available to all credit worthy customers, and that credit reporting agencies maintain separate credit histories on each individual upon request. The Ohio Civil Rights Commission administers compliance with this law.
                    <br />
                    Married applicants may apply for a separate account.
                    <br />
                    Same Day Funding available for clients completing the loan process and signing the
                    Promissory Note by 4:00PM ET on a business day. Also note, the ACH credit will be
                    submitted to your bank the same business day. This may result in same day funding,
                    but results may vary and your bank may have rules that limit our ability to credit
                    your account. We are not responsible for delays which may occur due to incorrect
                    routing number, account number, or errors of your financial institution.
                    <br />
                    Please refer to our{" "}
                    <Link href={`${appUrl}terms-of-service`}>
                        Terms of Use
                    </Link>{" "}
                    for additional terms and conditions, and to{" "}
                    <Link
                        href="//static.rocketloans.com/disclosures/our-privacy-notice.pdf"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Rocket Loans&#39; Privacy Notice
                    </Link>{" "}
                    and{" "}
                    <Link
                        href="//static.rocketloans.com/disclosures/bank-privacy-notice.pdf"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Cross River&#39;s Privacy Notice
                    </Link>{" "}
                    to learn more about what we do with your personal
                    information. For California residents, please see the{" "}
                    <Link
                        href="//static.rocketloans.com/disclosures/ca-financial-privacy-opt-out.pdf"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        California Financial Privacy Opt-Out Form
                    </Link>
                    .
                    <br />
                    NMLS #1399530. Go here for Rocket Loans&#39;{" "}
                    <Link
                        href="http://www.nmlsconsumeraccess.org/EntityDetails.aspx/COMPANY/1399530"
                    >NMLS consumer access page
                    </Link>.
                </Type.BodyFour>
                <Type.BodyFour>
                    Rocket Mortgage, LLC, Rocket Homes Real Estate LLC, RockLoans Marketplace LLC (doing business as Rocket Loans) and Rocket Auto LLC are separate operating subsidiaries of Rocket Companies, Inc. (NYSE: RKT). Each company is a separate legal entity operated and managed through its own management and governance structure as required by its state of incorporation and applicable legal and regulatory requirements.
                </Type.BodyFour>
                <br />
                <Type.BodyFour>
                    RockLoans Marketplace LLC dba RocketLoans dba Rocket Loans |
                    1050 Woodward Ave, Detroit, MI 48226
                </Type.BodyFour>
            </Fragment>
        );
    }
}

FooterDisclaimer.propTypes = {
    appUrl: PropTypes.string.isRequired,
    EHOLogo: PropTypes.string.isRequired
};

export default FooterDisclaimer;
